module.exports = __webpack_public_path__ + "img/beauty.0b585b12.svg";